import { render, staticRenderFns } from "./UserTrendInflowTable.vue?vue&type=template&id=170c0166&scoped=true"
import script from "./UserTrendInflowTable.vue?vue&type=script&lang=ts"
export * from "./UserTrendInflowTable.vue?vue&type=script&lang=ts"
import style0 from "./UserTrendInflowTable.vue?vue&type=style&index=0&id=170c0166&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170c0166",
  null
  
)

export default component.exports